





















































import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import Header from "@/components/Header.vue";
import { GapFilter, User } from "@/store/modules/types";
import { GapSubStatus } from "@/store/modules/enums";
import moment from "moment";

@Component({
  components: {
    Header,
  },
  computed: mapState("auth", ["user"]),
})
export default class Discharges extends Vue {
  user!: User;
  filter: GapFilter = {
    campaignId: "",
    insurerId: "",
    insurerMemberId: "",
    providerList: null,
    providerId: "",
    providerNPI: "",
    measureTypeId: "GAP",
    measureId: "",
    referenceDateFrom: null,
    referenceDateTo: null,
    priorityId: "",
    statusId: "",
    statusList: null,
    excludedStatusList: ["CLD"],
    subStatusId: "",
    subStatusList: null,
    excludedSubStatusList: null,
    recordDateFrom: null,
    recordDateTo: null,
    patientFirstName: "",
    patientLastName: "",
    patientInsurerMemberId: "",
    orderBy: "REF_DATE",
    pageNumber: 1,
    rowsPerPage: 100,
  };
  dates: Array<string> = [];
  pageRows = [];
  totalRows = 0;
  totalPatients = 0;
  get title() {
    if (this.pageRows.length) {
      return "Gaps (" + this.pageRows.length + ")";
    } else {
      return "Gaps";
    }
  }
  async getGaps() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch(
        "gaps/getUserEnrolledProviderGapList",
        this.filter
      );
      this.totalRows = data.totalRows;
      this.totalPatients = data.totalPatients;
      this.pageRows = data.pageRows.map((row) => {
        row.referenceDate = moment(row.referenceDate).format("YYYY-MM-DD");
        row.active = false;
        return row;
      });
      this.dates = this.pageRows.map((row) => row["referenceDate"]);
      this.dates = [...new Set(this.dates)];
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  showGap(gap) {
    this.$router.push({ name: "Gap", params: { id: gap.id } });
  }
  getGapsByRefDate(date) {
    return this.pageRows.filter((row) => row["referenceDate"] === date);
  }
  mounted() {
    this.getGaps();
  }
}
